import React, { useContext } from 'react';
import { DesignerDocument, DesignerNode } from './model';
import { TextRange } from './RichTextInput';

/** Alles, was ein einzelner Knoten-Editor vom Designer benötigt. */
export interface DesignerBridge {
  document: DesignerDocument;
  selectedId?: string;
  activeItemId?: string;
  readOnly?: boolean;
  headingNumbers: Map<string, string>;
  syncTokens: Record<string, number>;
  caret: { key: string; range: TextRange } | null;
  autoFocusKey: string | null;
  dragged?: string;
  select(nodeId: string, itemId?: string): void;
  update(nodeId: string, patch: Partial<DesignerNode>): void;
  remove(nodeId: string): void;
  duplicate(nodeId: string): void;
  move(nodeId: string, delta: number): void;
  setDragged(nodeId?: string): void;
  reorder(targetId: string): void;
  moveInto(containerId: string, columnId: string): void;
  onSelection(nodeId: string, itemId: string | undefined, range: TextRange | null): void;
  onSplit(nodeId: string, itemId: string | undefined, range: TextRange): void;
  onMergeBackward(nodeId: string, itemId?: string): void;
  onMergeForward(nodeId: string, itemId?: string): void;
  onIndent(nodeId: string, itemId: string | undefined, outdent: boolean): boolean;
}

export const DesignerContext = React.createContext<DesignerBridge | null>(null);

export function useDesigner(): DesignerBridge {
  const bridge = useContext(DesignerContext);
  if (!bridge) throw new Error('DesignerContext fehlt');
  return bridge;
}

export const caretKey = (nodeId: string, itemId?: string) => `${nodeId}:${itemId || ''}`;
